import { defineComponent as m, onMounted as b, onUnmounted as v, ref as u, unref as g, inject as h, computed as j, provide as O } from "vue";
import { t as S, H as y } from "./dom-B5R6OWVp.js";
let x = Symbol("DescriptionContext");
function k() {
  let t = h(x, null);
  if (t === null) throw new Error("Missing parent");
  return t;
}
function P({ slot: t = u({}), name: r = "Description", props: o = {} } = {}) {
  let e = u([]);
  function s(n) {
    return e.value.push(n), () => {
      let l = e.value.indexOf(n);
      l !== -1 && e.value.splice(l, 1);
    };
  }
  return O(x, { register: s, slot: t, name: r, props: o }), j(() => e.value.length > 0 ? e.value.join(" ") : void 0);
}
let M = m({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${S()}` } }, setup(t, { attrs: r, slots: o }) {
  let e = k();
  return b(() => v(e.register(t.id))), () => {
    let { name: s = "Description", slot: n = u({}), props: l = {} } = e, { id: p, ...c } = t, a = { ...Object.entries(l).reduce((i, [d, f]) => Object.assign(i, { [d]: g(f) }), {}), id: p };
    return y({ ourProps: a, theirProps: c, slot: n.value, attrs: r, slots: o, name: s });
  };
} }), C = Symbol("LabelContext");
function E() {
  let t = h(C, null);
  if (t === null) {
    let r = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(r, E), r;
  }
  return t;
}
function T({ slot: t = {}, name: r = "Label", props: o = {} } = {}) {
  let e = u([]);
  function s(n) {
    return e.value.push(n), () => {
      let l = e.value.indexOf(n);
      l !== -1 && e.value.splice(l, 1);
    };
  }
  return O(C, { register: s, slot: t, name: r, props: o }), j(() => e.value.length > 0 ? e.value.join(" ") : void 0);
}
let $ = m({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${S()}` } }, setup(t, { slots: r, attrs: o }) {
  let e = E();
  return b(() => v(e.register(t.id))), () => {
    let { name: s = "Label", slot: n = {}, props: l = {} } = e, { id: p, passive: c, ...a } = t, i = { ...Object.entries(l).reduce((d, [f, L]) => Object.assign(d, { [f]: g(L) }), {}), id: p };
    return c && (delete i.onClick, delete i.htmlFor, delete a.onClick), y({ ourProps: i, theirProps: a, slot: n, attrs: o, slots: r, name: s });
  };
} });
export {
  M as E,
  T as K,
  P as M,
  $ as T
};
//# sourceMappingURL=label-DS73oEMG.js.map
